jQuery(function ($) {
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset()?.top
        }, 500);
    });
});

window.onload = function () {
    if (document.querySelector('.yotpo .carousel-arrows')) {
        document.querySelector('.yotpo .carousel-arrows').style.setProperty('display', 'inline-block', 'important');
    }
};